import { Component, OnDestroy, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../_services/user.service';
import { Subscription } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import { MetaService } from 'ng2-meta';
import { AngularFirestore } from 'angularfire2/firestore';
import { ScrollService } from '../_services/scroll.service';


@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  private sub = new Subscription();
  userId = this.userService.getUid();
  category: string;
  brands: string;
  categories: any;
  subCategories;
  changeHashtagPost = [];
  username: any;
  y = [];
  mobileQuery: any;
  visible: any;
  categoryName: string;
  private _mobileQueryListener: () => void;

  constructor(
    private userService: UserService,
    private media: MediaMatcher,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private scrollService: ScrollService,
    private afs: AngularFirestore,
    private metaService: MetaService) {
    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

  }

  async ngOnInit() {
    this.sub = this.scrollService.isScroll.subscribe(a => {
      if (document.querySelector(".perfect-scrollbar").scrollTop > 620) {
        this.visible = true;

      }
      else {
        this.visible = false;

      }
    })

    this.subscription.add(this.route.params.subscribe(params => {
      this.category = params["category"];
      this.afs.collection('categories').ref.where('uniqueName', '==', this.category).get().then(a => {
        a.docs.map(b => {
          this.categories = b.data();
          this.username = b.data().name;
          this.metaService.setTitle(this.username + ' ' + '- Kullanıcı Yorumları, Müşteri Şikayet, Görüş ve Önerileri  | bigadvice.com');
          this.metaService.setTag('description', this.username + ' ' + "ile ilgili kullanıcı yorumları ve müşteri görüşleri bigadavice'ta buluşuyor. Burada sen de müşteri deneyimlerini herkesle paylaşabilir, diğer kullanıcıların yorumlarından ilham alabilirsin.");


        })
      })
      this.subCategories = this.afs.collection('categories', ref => ref.where('parent', '==', this.category)).valueChanges();

    }));


  }



  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
    this.sub.unsubscribe();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }



}
















// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/category/category.component.ts